/**
 * Extract the primary (first) item from a many-to-many alignment ID array.
 * Returns null when the array is empty, undefined, or null.
 *
 * Bridges the many-to-many data model with the single-select UI —
 * junction tables store arrays, but the UI presents one primary selection.
 */
export function primaryOf<T>(ids: T[] | undefined | null): T | null {
  return ids?.[0] ?? null;
}

/**
 * Count the total number of items in alignment arrays that have more than
 * one entry. Returns 0 when no multi-alignment exists.
 *
 * Used to detect silent-collapse scenarios: objectives loaded with >1
 * alignment that will be collapsed to a single selection on save.
 */
export function countMultiAlignmentItems(
  ...arrays: (unknown[] | undefined | null)[]
): number {
  return arrays
    .filter((ids): ids is unknown[] => (ids?.length ?? 0) > 1)
    .reduce((sum, ids) => sum + ids.length, 0);
}
